<form [formGroup]="form" class="preferences">
  <app-field-wrapper
    [class.tui-skeleton]="loading || saving"
    [text]="'components.preferences.labels.showUsers' | translate"
    [description]="'components.preferences.fields.showParentOrgUsersInLists' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="showParentOrgUsersInLists"></app-toggle>
  </app-field-wrapper>

  <app-field-wrapper
    [class.tui-skeleton]="loading || saving"
    [text]="'components.preferences.labels.showAllUsersPhonesAndEmails ' | translate"
    [description]="'components.preferences.labels.showAllUsersPhonesAndEmailsDescription' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="showAllUsersPhonesAndEmails"></app-toggle>
  </app-field-wrapper>

  <app-field-wrapper
    [class.tui-skeleton]="loading || saving"
    [text]="'components.preferences.labels.showOnlyChannels' | translate"
    [description]="'components.preferences.fields.showOnlyChannelsInNewsFeed' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="showOnlyChannelsInNewsFeed"></app-toggle>
  </app-field-wrapper>

  <ng-container *ngIf="messengerSettingsVisible">
    <app-field-wrapper
      [class.tui-skeleton]="loading || saving"
      [text]="'components.preferences.labels.createPublicChat' | translate"
      [size]="'s'"
    >
      <button tuiButton type="button" class="button" size="xs" (click)="createPublicChat()">
        <span class="button__label">
          {{ 'common.buttons.create' | translate }}
        </span>
      </button>
    </app-field-wrapper>
  </ng-container>

  <app-field-wrapper
    [class.tui-skeleton]="loading || saving"
    [text]="'components.preferences.fields.darkThemeByDefault' | translate"
    [description]="'components.preferences.labels.darkThemeByDefaultDescription' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="darkThemeByDefault"></app-toggle>
  </app-field-wrapper>

  <div class="preference" [class.tui-skeleton]="loading || saving">
    <app-field-wrapper
      [text]="'components.preferences.fields.allowUserRegistrationForm' | translate"
      [description]="'components.preferences.labels.allowUserRegistrationFormDescription' | translate"
      [size]="'s'"
    >
      <app-toggle formControlName="allowUserRegistrationForm"></app-toggle>
    </app-field-wrapper>

    <ng-container *ngIf="!!form.value.allowUserRegistrationForm">
      <div *ngIf="!!userRegistrationLink">
        <app-link
          [url]="userRegistrationLink"
          [displayText]="'components.preferences.labels.userRegistrationLink' | translate"
          [pseudo]="true"
        ></app-link>

        <app-copy-to-clipboard-button [link]="userRegistrationLink" [size]="'xs'"></app-copy-to-clipboard-button>
      </div>

      <button
        tuiButton
        class="preference__button"
        type="button"
        appearance="primary"
        [size]="'xs'"
        [routerLink]="'/settings/administration/standard-user-info-fields'"
      >
        <span>
          {{ 'components.preferences.buttons.editRegistrationForm' | translate }}
        </span>
      </button>
    </ng-container>
  </div>

  <ng-container *tuiLet="form.get('templateForNewcomerOld')?.value as oldDocumentValue">
    <app-input-files
      *ngIf="!!oldDocumentValue"
      class="size_{{ tuiElementLargeSize }}"
      [link]="'components.preferences.fields.fileLink' | translate"
      [label]="' '"
      formControlName="templateForNewcomerOld"
      [maxFileSize]="maxDocFileSize"
      [tuiTextfieldSize]="tuiElementLargeSize"
      [size]="tuiElementLargeSize"
      [loading]="loading || saving"
    ></app-input-files>

    <ng-container *ngIf="!oldDocumentValue">
      <ng-container *tuiLet="form.get('templateForNewcomerNew')?.value as newDocumentValue">
        <app-input-files
          class="size_{{ tuiElementLargeSize }}"
          [link]="'components.preferences.fields.fileLink' | translate"
          [label]="' '"
          formControlName="templateForNewcomerNew"
          [maxFileSize]="maxDocFileSize"
          [tuiTextfieldSize]="tuiElementLargeSize"
          [size]="tuiElementLargeSize"
          [loading]="loading || saving"
        ></app-input-files>
      </ng-container>
    </ng-container>
  </ng-container>

  <app-field-wrapper
    *ngxPermissionsOnly="'preferenceShowOnlyLoyaltyProgramEditing'"
    [class.tui-skeleton]="loading || saving"
    [text]="'components.preferences.fields.showOnlyLoyaltyProgram' | translate"
    [description]="'components.preferences.fields.showOnlyLoyaltyProgramDescription' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="showOnlyLoyaltyProgram"></app-toggle>
  </app-field-wrapper>
</form>
